import React from 'react';
import { useLocation } from 'react-router-dom';
import ErrorBoundary from './ErrorBoundary';
import type { AppCrashPageVariant } from './AppCrashPage';

interface RouteErrorBoundaryProps {
  children: React.ReactNode;
  variant?: AppCrashPageVariant;
}

const RouteErrorBoundary: React.FC<RouteErrorBoundaryProps> = ({
  children,
  variant = 'app',
}) => {
  const location = useLocation();
  const resetKey = `${location.pathname}${location.search}`;

  return (
    <ErrorBoundary resetKey={resetKey} variant={variant}>
      {children}
    </ErrorBoundary>
  );
};

export default RouteErrorBoundary;
